import React from 'react';
import { motion } from 'framer-motion';
import styles from './WinnerStyles.module.css';
import hum from '../../assets/images/hum.png';
import { useBroadcast } from '../../hooks/useBroadcast';

function Winner({ questionImgUrl, winnerFontSize }) {
  const { currentMessage } = useBroadcast();

  const errorHandler = (e) => {
    e.target.src = hum;
  };
  return (
    <>
      {currentMessage && (
        <div
          className={styles.winnerWrapper}
          key={currentMessage?.message.author}>
          <motion.div
            initial={{ opacity: 0, transform: 'scale(0)' }}
            animate={{ opacity: 1, transform: 'scale(0.9)' }}
            transition={{ duration: 1, delay: questionImgUrl ? 3.3 : 2 }}
            className={styles.imgBlock}>
            <img
              src={
                (currentMessage?.message.image &&
                  currentMessage?.message.image !== '1' &&
                  currentMessage?.message.image) ||
                hum
              }
              alt="Фото"
              onError={errorHandler}
            />
            <motion.div
              className={styles.circleOne}
              animate={{
                y: [0, -20, -10, 0],
                x: [0, -20, -10, 0],
              }}
              transition={{
                duration: 5,
                ease: 'easeInOut',
                repeat: Infinity,
                repeatDelay: 0,
              }}
            />
            <motion.div
              className={styles.circleTwo}
              animate={{
                y: [0, 20, 10, 0],
                x: [0, 20, 10, 0],
              }}
              transition={{
                duration: 5,
                ease: 'easeInOut',
                repeat: Infinity,
              }}
            />
          </motion.div>
          <motion.div
            initial={{ x: 1000 }}
            animate={{ x: 0 }}
            transition={{ duration: 0.5, delay: questionImgUrl ? 4.55 : 3.25 }}
            className={styles.winnerName}
            style={{ fontSize: `${winnerFontSize}rem` }}>
            <div>{currentMessage?.message.author}</div>
          </motion.div>
        </div>
      )}
    </>
  );
}

export default Winner;
